<script setup lang="ts"></script>

<template>
  <icon name="iconoir:sort-down" />
</template>

<style scoped></style>
